import styles from "./campaign-list.module.css";

export function CampaignListPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Campaign</h1>
      <div className={styles.comingSoon}>
        <p className={styles.comingSoonText}>Coming soon.</p>
        <p className={styles.comingSoonFact}>Campaign tools arrive with the ads service.</p>
      </div>
    </div>
  );
}
